import axios from "axios";
import { getHttpConfig } from "../../../../../../Utils/Helpers/common";


export const portfolioapproval = {
  FILTERVALUE: "filterValue",
  TEMPLATEID: "templateId",
  TEMPLATEFILTERID: "templateFilterID",
  CURRENTPATHNAME:"currentPathName"
};
export function regexMatchAndReplaceFromDocument(inputText, regexPattern) {
  let placeholderMatches = inputText.matchAll(regexPattern);
  let currentValue = placeholderMatches.next();
  while (!currentValue.done) {
    let [placeholder, placeholderId] = currentValue;
    let customHtml =
      placeholderId &&
      document.getElementById(placeholderId) &&
      document.getElementById(placeholderId).innerHTML
        ? document.getElementById(placeholderId).innerHTML
        : "";
    if (customHtml) {
      inputText = inputText.replace(placeholder, customHtml);
    }
    currentValue = placeholderMatches.next();
  }
  return inputText;
}

export const getPPtData = async (Ids, { signal } = {}) => {
  let url = `${process.env.PPT_DOWNLOAD_URL}/PPT/process/ping`;

  try {
    const data = await httpPostCustom(url, Ids, { signal }); 
    return data;
  } catch (error) {
    if (error.name === "AbortError") {
      // eslint-disable-next-line no-console
      console.log("Fetch request was aborted.");
      return null; 
    }
    throw error;
  }
};

 const httpPostCustom = async (
  url,
  data = {},
  config = {},
  completeResReturn = false
) => {
  if (!config.headers) {
    config.headers = {};
  }
  const baseUrl = process.env.API_URL;
  const httpConfig = getHttpConfig();
  config.headers.Authorization = httpConfig.headers.Authorization;

  if (!config.signal && typeof AbortController !== "undefined") {
    config.signal = new AbortController().signal;
  }

  let finalUrl = url.startsWith("http") ? url : `${baseUrl}${url}`;

  try {
    const response = await axios.post(finalUrl, data, config);
    return completeResReturn ? response : response.data;
  } catch (error) {
    if (axios.isCancel(error)) {
       // eslint-disable-next-line no-console
      console.log("Request was canceled:", error.message);
      return null; 
    }
    throw error; 
  }
};

